import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import _ from 'lodash'
import Spinner from 'react-spinkit'
import constants from '../../../lib/constants'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

class DeviceView extends React.Component {
  static defaultProps = {
    device: {},
    jobs: [],
    loadJobsForDevice: _.noop,
    params: {},
    isStaff: false,
    isProvider: false
  }

  static propTypes = {
    params: PropTypes.shape({}),
    jobs: PropTypes.arrayOf(PropTypes.shape({})),
    loadJobsForDevice: PropTypes.func,
    reenqueueJob: PropTypes.func,
    cancelJob: PropTypes.func,
    passJob: PropTypes.func,
    isStaff: PropTypes.bool,
    isProvider: PropTypes.bool,
    location: PropTypes.shape({
      pathname: PropTypes.string
    }),
    device: PropTypes.shape({
      data: {
        name: PropTypes.string
      }
    }),
    getDevice: PropTypes.func,
  }

  constructor (props) {
    super(props)
    this.state = {
      page: 1,
      loading: true,
      hasMorePages: true, 
      lastPageWithData: 1,
      searchJobId: ''
    }
  }

  componentDidMount () {
    const { loadJobsForDevice, getDevice, params, location } = this.props
    const urlParams = new URLSearchParams(location.search)
    const pageFromUrl = parseInt(urlParams.get('page')) || 1
    
    this.setState({ 
      page: pageFromUrl,
      lastPageWithData: pageFromUrl
    })
    
    getDevice(params.device_string)
    loadJobsForDevice(params.device_string, pageFromUrl)
    .then((apiJobs) => {

      const hasJobs = apiJobs && apiJobs.length > 0
      this.setState(prevState => ({
        loading: false,
        hasMorePages: apiJobs && apiJobs.length >= 10,
        lastPageWithData: hasJobs ? pageFromUrl : prevState.lastPageWithData
      }))
    })
  }

  setPage = (page) => {
    const { loadJobsForDevice, params, location } = this.props
    const newPage = _.max([page, 1])
    
    const { hasMorePages, lastPageWithData } = this.state
    if (newPage > lastPageWithData && !hasMorePages) {
      return 
    }
    
    const urlParams = new URLSearchParams(location.search)
    urlParams.set('page', newPage)
    const newUrl = `${location.pathname}?${urlParams.toString()}`
    window.history.pushState(null, '', newUrl)
    
    this.setState({
      loading: true,
      page:newPage
    })
    loadJobsForDevice(params.device_string, newPage)
    .then((apiJobs) => {
      const hasJobs = apiJobs && apiJobs.length > 0
      
      // If no jobs on this page and we're beyond known data
      if (!hasJobs && newPage > this.state.lastPageWithData) {
        // We've gone past the last page with data - go back to last valid page
        const urlParams = new URLSearchParams(location.search)
        urlParams.set('page', this.state.lastPageWithData)
        const backUrl = `${location.pathname}?${urlParams.toString()}`
        window.history.replaceState(null, '', backUrl)
        
        this.setState({
          loading: false,
          hasMorePages: false,
          page: this.state.lastPageWithData
        })
        return
      }
      
      const hasMorePagesCalculated = apiJobs && apiJobs.length >= 10
      
      this.setState(prevState => ({
        loading: false,
        hasMorePages: hasMorePagesCalculated,
        lastPageWithData: hasJobs ? Math.max(prevState.lastPageWithData, newPage) : prevState.lastPageWithData
      }))
    })
  }

  renderValue = (val, errorMessage) => {
    const { isStaff } = this.props
    if (!isStaff && errorMessage) {
      return null
    } else {
      if (_.isNumber(val)) {
        return Number(val.toFixed(1))
      } else {
        return val
      }
    }
  }

  pokeJob = (jobId) => {
    const { reenqueueJob } = this.props
    reenqueueJob(jobId)
  }

  cancelJob = (jobId) => {
    const { cancelJob } = this.props
    cancelJob(jobId)
  }

  passJob = (jobId) => {
    const { passJob } = this.props

    confirmAlert({
      title: 'Pass Job',
      message: `Are you sure you want to pass job ${jobId}`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            passJob(jobId).then((result) => {
              if (result.success === true) {
                alert('Job Passed')
              }
            })
          }
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    })
  }

  handleJobSearch = () => {
    const { searchJobId } = this.state
    if (searchJobId.trim()) {
      // Navigate to job images page
      window.location.href = `/jobs/${searchJobId}/images`
    }
  }

  handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.handleJobSearch()
    }
  }

  render () {
    const { device, jobs, params, isStaff } = this.props
    const { page, loading, searchJobId } = this.state
    const sortedJobs = _.sortBy(jobs, (job) => {
      if (job.start_time) {
        return new Date() - new Date(job.start_time)
      } else {
        return new Date() - new Date(job.created_at)
      }
    })
    const filteredJobs = _.filter(sortedJobs, (job) => {
      return job.job_id
    })
    const pageSize = 10
    const startItem = pageSize * (page - 1)
    const endItem = pageSize * page
    const paginatedJobs = filteredJobs.slice(startItem, endItem)
    const { pathname } = this.props.location

    const jobRows = _.map(paginatedJobs, (job) => {
      const isHemoglobin = ['hemoglobin', 'hemoglobin_green'].includes(job.strip_type)
      let avgRgb = 0.0
      if (isHemoglobin) {
        const rgbValues = job.rgb_values ? job.rgb_values : "[0]"
        const rgbValuesNoOutliers = job.rgb_values_excluding_outliers ? job.rgb_values_excluding_outliers : "[0]"
        const parsedRgbValues = JSON.parse(rgbValues)
        const parsedRgbValuesNoOutliers = JSON.parse(rgbValuesNoOutliers)
        var avgBlankRgb = 0
        var avgBloodRgb = 0
        if (parsedRgbValues.length == 2) {
          const blankRgbValues = parsedRgbValues[0]
          const bloodRgbValues = parsedRgbValues[1]
          avgBloodRgb = (bloodRgbValues.reduce((a,b) => a + b, 0) / bloodRgbValues.length).toFixed(2)
          if (blankRgbValues.length > 0) {
            avgBlankRgb = (blankRgbValues.reduce((a,b) => a + b, 0) / blankRgbValues.length).toFixed(2)
          }
        } else {
            avgBloodRgb = (parsedRgbValues.reduce((a,b) => a + b, 0) / parsedRgbValues.length).toFixed(2)
        }
        avgRgb = [avgBlankRgb, avgBloodRgb]
      }
      return (
        <tr key={job.job_id}>
          <td>
            {
              isStaff ? (
                <div>
                  <p>
                    <Link to={`/jobs/${job.job_id}/images`}>
                      Job ID:{job.job_id}{job.note ? ` Note: ${job.note}` : null}
                    </Link>
                  </p>
                  <p>
                    <a href={`${constants.STORAGE_URL}${constants.DEVICE_LOGS_BUCKET}/${job.device_string}/${job.job_id}/?project=${constants.PROJECT}`}target='_blank'>
                      Log File
                    </a>
                  </p>
                  <p>
                    <a href={`${constants.STORAGE_URL}${constants.PULLBACK_VIDEO_BUCKET}/${job.device_string}/${job.job_id}_pullback_video.mp4/?project=${constants.PROJECT}`} target='_blank'>
                    Pullback Video
                  </a>
                  </p>
                  <p>
                    <a href={`${constants.STORAGE_URL}_details/${constants.PULLBACK_IMAGE_BUCKET}/${job.job_id}_pullback_img_1.jpg/?project=${constants.PROJECT}`} target='_blank'>
                    Pullback Img 1
                  </a>
                  </p>
                  <p>
                    <a href={`${constants.STORAGE_URL}_details/${constants.PULLBACK_IMAGE_BUCKET}/${job.job_id}_pullback_img_2.jpg/?project=${constants.PROJECT}`} target='_blank'>
                    Pullback Img 2
                  </a>
                  </p>
                </div>
              ) : (
                <p>{job.job_id}</p>
              )
              }
          </td>
          <td>{job.operator_object ? `${job.operator_object.first_name} ${job.operator_object.last_name}` : null }</td>
          <td>{job.patient_id}</td>
          <td>
            {job.job_status}
            { (job.job_status === constants.JOB_STATUSES.QUEUED)
                ? <div>{ device.is_strip_present ? 'Strip detected' : 'No strip detected' }</div>
                : null }
            { (job.job_status === constants.JOB_STATUSES.PROCESSING && isStaff)
                ? <button
                  className='btn btn-small btn-outline-secondary'
                  onClick={() => this.pokeJob(job.job_id)}>Reprocess</button>
                : null }
            { (constants.CANCELLABLE_JOB_STATUSES.indexOf(job.job_status) > -1)
                ? <button
                  className='btn btn-small btn-outline-secondary'
                  onClick={() => this.cancelJob(job.job_id)}>Cancel</button>
                : null }
          </td>
          <td>
            {job.job_status === constants.JOB_STATUSES.COMPLETED &&
              job.strip_type === constants.STRIP_TYPES.WBC &&
              !job.did_strip_pullback
              ? <div className='alert alert-warning'>The strip was not detected. Please reinsert and try again.</div>
              : null}
            <div>
              { job.error_message
                ? <div>
                  {job.error_message}
                  <br/>
                  <button onClick={() => this.passJob(job.job_id)}>Pass Job</button>
                </div>
                : 'None'}
            </div>
          </td>
          <td>
            {job.flag ? constants.FLAG_MESSAGES[job.flag] : 'No Flag'}
          </td>
          <td>{this.renderValue(job.wbc_count, job.error_message)}</td>
          <td>{this.renderValue(job.neutrophils, job.error_message)} %</td>
          <td>{this.renderValue(job.wbc_count * job.neutrophils / 100, job.error_message)}</td>
          { isStaff ? <td>{job.platelet_concentration}</td> : null }
          { isStaff && isHemoglobin ? <td>AVG: {avgRgb.toString()} <br/> BR: {job.blank_reference ? job.blank_reference :
           0.0} <br/> RGB: {job.rgb_values_excluding_outliers ? job.rgb_values_excluding_outliers.replaceAll(']', '[') : null} <br/> HB: {job.hb_count}</td> : null}
          { isStaff && !isHemoglobin ? <td>RGB: {job.rgb_values_excluding_outliers ? job.rgb_values_excluding_outliers.replaceAll(']', '[') : null} <br/> HB: {job.hb_count}</td> : null }
          <td>{job.start_time ? new Date(job.start_time).toLocaleString() : null}</td>
          <td>{job.completion_time ? new Date(job.completion_time).toLocaleString() : null}</td>
          <td>{job.strip_type}</td>
          <td>{job.test_strip_lot}</td>
        </tr>
      )
    })

    const { hasMorePages, lastPageWithData } = this.state
    const pageNumbers = []
    
    const effectiveLastPage = Math.max(lastPageWithData, page)
    const actualLastPage = hasMorePages ? effectiveLastPage + 1 : effectiveLastPage
    
    
    const start = Math.max(1, page - 2)
    const end = Math.min(page + 2, actualLastPage)
    
    for (let i = start; i <= end; i++) {
      pageNumbers.push(i)
    }
    return (
      <div style={{ height: '80vh' }}>
        {
          isStaff ? (
            <div>
              <a href={`${constants.STORAGE_URL}${constants.DEVICE_LOGS_BUCKET}/${params.device_string}/debug?project=${constants.PROJECT}`}
                target={'_blank'}
              >
                Debug Logs
              </a>
            </div>
          ) : null
        }
        <ul className='nav nav-tabs' style={{ marginBottom: 20 }}>
          <li className='nav-item'>
            <Link className={`nav-link ${pathname.indexOf('stats') === -1 ? 'active' : ''}`}
              to={`/device/${params.device_string}/`}>
              Results
            </Link>
          </li>
          <li className='nav-item'>
            <Link className={`nav-link ${pathname.indexOf('stats') === 0 ? 'active' : ''}`}
              to={`/device/${params.device_string}/stats`}>
              Stats
            </Link>
          </li>
        </ul>
        <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', gap: 10 }}>
          <input
            type='text'
            className='form-control'
            style={{ width: 200 }}
            placeholder='Search Job ID...'
            value={searchJobId}
            onChange={(e) => this.setState({ searchJobId: e.target.value })}
            onKeyDown={this.handleSearchKeyDown}
          />
          <button
            className='btn btn-primary'
            onClick={this.handleJobSearch}
            disabled={!searchJobId.trim()}
          >
            Go to Job Images
          </button>
        </div>
        <nav aria-label='...'>
          <ul className='pagination'>
            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
              <a className='page-link' onClick={() => this.setPage(page - 1)} tabIndex='-1'>Previous</a>
            </li>
            {
              _.map(pageNumbers, (pageNumber) => (
                <li
                  className={`page-item ${pageNumber === page ? 'active' : ''}`}
                  key={pageNumber}
                >
                  <a className='page-link' onClick={() => this.setPage(pageNumber)}>
                    {pageNumber}
                    <span className='sr-only'>
                      (current)
                    </span>
                  </a>
                </li>
              ))
            }
            <li className={`page-item ${(page >= lastPageWithData && !hasMorePages) ? 'disabled' : ''}`}>

              <a className='page-link' onClick={() => this.setPage(page + 1)}>Next</a>
            </li>
          </ul>
        </nav>
        <div style={{ padding: 20, textAlign: 'left' }}>
          <div>Device: { _.get(device, ['data', 'name']) }</div>
          <div>Hardware Version: { _.get(device, ['hardware_version']) }</div>
        </div>
        {
          !loading
          ? (
            <div className='table-responsive'>
              <table className='table'>
                <thead className='thead-dark'>
                  <tr>
                    <th scope='col'>Job Id</th>
                    <th scope='col'>Operator Name</th>
                    <th scope='col'>Patient ID</th>
                    <th scope='col'>Status</th>
                    <th scope='col' style={{ width: '300px' }}>Error Message</th>
                    <th scope='col' style={{ width: '150px' }}>Flagging Message</th>
                    <th scope='col'>WBC (K/µL)</th>
                    <th scope='col'>Neutrophil</th>
                    <th scope='col'>ANC (K/µL)</th>
                    { isStaff ? <th scope='col'>PLT (K/µL)</th> : null }
                    { isStaff ? <th scope='col'>HB</th> : null }
                    <th scope='col'>Start Time</th>
                    <th scope='col'>Completion Time</th>
                    <th scope='col'>Strip Type</th>
                    <th scope='col'>Test Strip Lot</th>
                  </tr>
                </thead>
                <tbody>
                  {jobRows}
                </tbody>
              </table>
            </div>
          )
        : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Spinner name='double-bounce' color='red' />
          </div>)
        }
      </div>
    )
  }
}

export default DeviceView



// WEBPACK FOOTER //
// ./src/routes/Device/components/DeviceView.js